import * as React from "react"

interface IconProps {
  color?: string
}

export const DeleteIcon: React.FunctionComponent<IconProps> = ({ color = "#616161" }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.25 19C7.8375 19 7.4845 18.8478 7.191 18.5434C6.897 18.2386 6.75 17.8722 6.75 17.4444V7.33333H6V5.77778H9.75V5H14.25V5.77778H18V7.33333H17.25V17.4444C17.25 17.8722 17.1033 18.2386 16.8097 18.5434C16.5157 18.8478 16.1625 19 15.75 19H8.25ZM15.75 7.33333H8.25V17.4444H15.75V7.33333ZM9.75 15.8889H11.25V8.88889H9.75V15.8889ZM12.75 15.8889H14.25V8.88889H12.75V15.8889Z"
      fill={color}
    />
  </svg>
)
